export default __webpack_public_path__ + "static/media/truthtake1.0496e84f.mp3";